<template>
  <div v-if="title || description || button || subtitle" class="text-center max-w-250 mx-auto">
    <p v-if="subtitle" class="mb-5 lg:mb-7.5 text-pink font-title uppercase text-sm" v-reveal>
      {{ subtitle }}
    </p>
    <h2
      v-if="title"
      :class="[
        'mb-5 text-4xl lg:text-6xl',
        {
          'font-title uppercase': !subtitle,
          'font-subtitle lg:leading-18': subtitle,
        },
      ]"
      v-reveal="{ delay: 200 }"
    >
      {{ title }}
    </h2>
    <p
      v-if="description"
      class="max-w-200 mx-auto whitespace-break-spaces"
      v-reveal="{ delay: 250 }"
    >
      {{ description }}
    </p>
    <SiteLink
      v-if="button"
      :content="button"
      class="mt-10 mx-auto button"
      v-reveal="{ delay: 300 }"
    />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'

import SiteLink from '@/components/helpers/SiteLink.vue'

export default {
  name: 'CTABlock',
  components: { SiteLink },
  props: {
    button: {
      type: Object as PropType<Link | null>,
      default: null,
    },
    description: {
      type: String as PropType<string | null>,
      default: null,
    },
    subtitle: {
      type: String as PropType<string | null>,
      default: null,
    },
    title: {
      type: String as PropType<string | null>,
      default: null,
    },
  },
}
</script>
